import React, { Component } from "react";
import { Input } from "antd";
import { FaSearch } from "react-icons/fa";
import searchIcon from "../../assets/search.png"
import "./Search.scss";
import ContactTab from '../../components/Tabs/ContactTab'

const { Search } = Input;
const suffix = (
  <FaSearch
    style={{
      fontSize: 20,
      color: "#939598",
    }}
  />
);

export default class SearchView extends Component {

  state = {
    showResult : false
  }

  onSearch = (value) => {
    //console.log(value);
    this.setState({ showResult : true})
  } 

  render() {
    const { showResult } = this.state;
    return (
      <div className="search-page-wrapper">
        <div className="search-top-content">
          <div className="container">
            <div className="order-tabs-header">
              <div className="order-header-content">
                <h1>البحث العام</h1>
                <div className="order-header-search">
                  <Search
                    placeholder="البحث برقم الطلب٬ اسم العميل٫ جوال العميل٫ رقم هويه العميل"
                    allowClear
                    enterButton=" بحث"
                    size="large"
                    prefix={suffix}
                    onSearch={this.onSearch}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="search-result-holder">
          <div className="container"> 
          {showResult ? 
                    <ContactTab noHeader showType="bonds" title="السندات" /> : 

            <div className="result-content">
                <img src={searchIcon} alt="" />
                <h3 className="search-title">لا توجد نتائج بحث</h3>
                <p className="search-label">قم بالبحث برقم الطلب٬ اسم العميل٫ جوال العميل٫ رقم هويه العميل</p>
            </div>
        }
          </div>
        </div>
      </div>
    );
  }
}
